import {FC} from 'react';
import {Chip} from '@mui/material';
import {ReceiptLongOutlined} from '@mui/icons-material';
import {useIntl} from 'react-intl';
import {PhoneCardHead} from 'src/components/mobile/PhoneCardHead';
import {PhoneCardFacts} from 'src/components/mobile/PhoneCardFacts';
import {TableCard} from 'src/components/tables/respnsiveTable/TableCard';
import {CustomInvoiceItemDTO} from 'src/types';
import {
    DescriptionCell,
    formatPrice,
} from 'src/components/common/CustomInvoiceItemsTable/CustomInvoiceItemsTable.tableConfig';
import {priceChipSx} from 'src/components/common/CustomInvoiceItemsTable/CustomInvoiceItemsTable.sx';

interface LinkedInvoiceItemCardProps {
    item: CustomInvoiceItemDTO;
    currency: string;
}

/**
 * One linked invoice item as a card. It carries the facts the columns carry and renders them
 * through the same cells, so the description reads in the same languages and the price in the same
 * units whichever form of the list the reader is looking at.
 *
 * It has no menu and no status of its own: an item reached through its invoice is already settled,
 * so the card is an identity and its two numbers.
 */
export const LinkedInvoiceItemCard: FC<LinkedInvoiceItemCardProps> = ({item, currency}) => {
    const intl = useIntl();

    return (
        <TableCard>
            <PhoneCardHead
                icon={<ReceiptLongOutlined/>}
                title={<DescriptionCell row={item}/>}
            />
            <PhoneCardFacts
                facts={[
                    {
                        label: intl.formatMessage({id: 'quantity'}),
                        value: item.quantity,
                    },
                    {
                        label: intl.formatMessage({id: 'priceInclVat'}),
                        value: (
                            <Chip
                                label={`${formatPrice(item.price)} ${currency}`}
                                size="small"
                                sx={priceChipSx}
                            />
                        ),
                    },
                ]}
            />
        </TableCard>
    );
};
